import store from '@/store'
export default {
  inserted(el, binding) {
    const btnPermissionList = store.state.user.btns
    const { value } = binding
    const index = btnPermissionList.findIndex(item => item.code === value)
    // const flag = production || useBtnPermission // 生产环境开启权限，开发时则根据配置来
    // if (index < 0 &&  process.env.NODE_ENV === 'production') {
    if (index < 0) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
}
